<template>
  <!--回复-->
  <div aria-labelledby="myModalLabel" class="modal fade" id="review" role="dialog" tabindex="-1">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="iconfont icon-close"></i>
          </button>
          <h4 class="modal-title" id="myModalLabel">回复</h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <textarea
              class="form-control"
              :placeholder="placeholder"
              style="resize: vertical;"
              rows="10"
              v-model="content"
              name="content"
              data-vv-as="回复内容 "
              v-validate="{ required:true, min:1,max:500 }"
            ></textarea>
            <span class="help-block" v-show="errors.has('content')">{{ errors.first('content') }}</span>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" data-dismiss="modal" type="button">取消</button>
          <button class="btn btn-primary" type="button" @click="createComment">回复</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createComment } from "@/api/topic/topic";
export default {
  name: "GroupReview",
  data() {
    return {
      content: ""
    };
  },
  props: {
    comment: {
      type: Object
    }
  },
  computed: {
    placeholder() {
      return this.comment.commentNumber
        ? "回复 " + this.comment.commentToName + "："
        : "说点什么...";
    }
  },
  methods: {
    createComment() {
      this.$validator.validate().then(valid => {
        if (valid) {
          createComment({
            topic_number: this.comment.topicNumber,
            topic_comment_to_number: this.comment.commentNumber,
            topic_comment_content: this.comment.commentNumber
              ? "@" + this.comment.commentToName + ": " + this.content
              : this.content
          })
            .then(res => {
              if (res.status_code === 200) {
                $("#review").modal("hide");
                this.$message({
                  type: "success",
                  message: res.message
                });
                this.content = "";
                this.$emit("refreshTopic");
                this.$nextTick(() => {
                  this.$validator.reset();
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message
                });
              }
            })
            .catch(err => {
              this.$message({
                type: "error",
                message: err
              });
            });
        }
      });
    }
  }
};
</script>

<style scoped>
</style>